import { MouseEvent, useEffect, useRef, useState } from 'react';

import { CheckboxBlock } from '@/lib/widgets/catalog';

import { LOWERCASE_SAMUI_DISTRICTS_ALL } from '@/lib/entities/domain';

import { SamuiMap } from '@/lib/shared/icons';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from 'nuqs';

import styles from './SamuiMapWithBeaches.module.scss';

type Props = {
  isShow?: boolean;
  type: 'rent' | 'sale';
};
export const SamuiMapWithBeaches = ({ isShow, type }: Props) => {
  const { t } = useTranslation('index');
  const [selectedIds] = useQueryState(
    'samuiDistrict',
    parseAsArrayOf(
      parseAsStringLiteral(LOWERCASE_SAMUI_DISTRICTS_ALL)
    ).withDefault([])
  );
  const mapRef = useRef<HTMLDivElement>(null);
  const [ids, setIds] = useState<{ id: string; isDisabled: boolean }[]>([]);
  useEffect(() => {
    if (mapRef.current) {
      const foundIds = mapRef.current.querySelectorAll('path[id]');

      setIds(
        Array.from(foundIds).map((item) => ({
          id: item.id,
          isDisabled: (
            document.querySelector(`input[id=${item.id}]`) as HTMLInputElement
          )?.disabled,
        }))
      );
    }
  }, []);

  return (
    <div
      ref={mapRef}
      className={styles.map}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        if (!('id' in e.target)) return;
        const id = e.target.id as string;
        const checkbox = e.currentTarget?.querySelector(
          `input[id='${id}']`
        ) as HTMLInputElement;
        if (checkbox) {
          checkbox.click();
          checkbox.blur();
        }
      }}
    >
      <SamuiMap
        className={clsx(
          styles.map__samui,
          isShow && styles['map__samui--show']
        )}
        id="SamuiFilterMap"
        selectedIds={selectedIds}
        t={t}
        shouldHighlight
      />
      {ids.length > 0 && (
        <CheckboxBlock
          catalogQuery="samuiDistrict"
          isHidden
          items={ids.map((id) => ({
            value: id.id,
            label: id.id,
            id: id.id,
            isDisabled: id.isDisabled,
          }))}
          type={type}
        />
      )}
    </div>
  );
};
